<div class="theme-ai-evaluation" [formGroup]="ai()">
    <h4 class="section-title">Scoring and Detection Rules</h4>
    <p class="section-subtitle">
        The full rubric for spam handling, voice-energy evaluation, and
        score-band definitions.
        <span class="body-1">For voice/text interactives only.</span>
    </p>

    <div class="cards">
        <div class="card split">
            <div class="field">
                <div class="field-header">
                    <h5 class="card-title">Spam Detection</h5>
                    <p class="card-subtitle">
                        Show-specific spam overrides. Leave blank to fall back
                        to the default detection behavior.
                    </p>
                </div>
                <tools-textarea
                    placeholder="e.g., Mark as spam if the submission contains targeted harassment terms, repeated promotional content, or known troll phrases..."
                    [maxLength]="criteriaMaxLength"
                    formControlName="spamCriteria"
                ></tools-textarea>
            </div>
        </div>

        <div class="card split">
            <div class="field">
                <div class="field-header">
                    <h5 class="card-title">Audio Energy Label</h5>
                    <p class="card-subtitle">
                        Used for the 1-5 energy meter in the producer dashboard.
                        Will default to “Intensity” if left blank.
                    </p>
                </div>
                <tools-input-outline
                    label="Audio Energy Label"
                    placeholder="Enter a label for internal use (listeners won't see this)"
                    [maxLength]="labelMaxLength"
                    formControlName="audioEnergyLabel"
                ></tools-input-outline>
            </div>

            <div class="field">
                <div class="field-header">
                    <h5 class="card-title">Audio Energy Criteria</h5>
                    <p class="card-subtitle">
                        How the AI should judge passion and delivery in voice
                        takes.
                    </p>
                </div>
                <tools-textarea
                    placeholder="e.g., An integer 1 to 5 that scores the caller's ENERGY. Look for: pitch variation, rapid delivery, emphatic phrases, exclamations..."
                    [maxLength]="criteriaMaxLength"
                    formControlName="audioEnergyScoreCriteria"
                ></tools-textarea>
            </div>
        </div>
    </div>

    <h4 class="section-title bands-title">Score Bands</h4>
    <p class="section-subtitle">
        The criteria the AI applies at each score range.
    </p>

    <div class="grid">
        @for (band of bands; track band.control) {
            <div class="card">
                <div class="card-header">
                    <span class="score-pill" [ngClass]="band.tier">
                        {{ band.label }}
                    </span>
                    <span class="range-label">Score Range</span>
                </div>
                <tools-textarea
                    placeholder="Describe what earns a score in this range."
                    [maxLength]="criteriaMaxLength"
                    [formControlName]="band.control"
                ></tools-textarea>
            </div>
        }
    </div>
</div>
